var map = {
	"./Default": [
		4772,
		[
			772
		]
	],
	"./Default.js": [
		4772,
		[
			772
		]
	],
	"./Home": [
		4102,
		[
			102
		]
	],
	"./Home.js": [
		4102,
		[
			102
		]
	],
	"./Legal": [
		7280,
		[
			280
		]
	],
	"./Legal.js": [
		7280,
		[
			280
		]
	],
	"./Post": [
		411,
		[
			411
		]
	],
	"./Post.js": [
		411,
		[
			411
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8086;
module.exports = webpackAsyncContext;